import { GameDisallowedReason } from './game-disallowed-reason';

/**
 * The available game modes.
 * More than 1 game may have the same game mode.
 */
export enum GameId {
  ActionGame = 'AG',
  Terraforming = 'TF',
  Arcade = 'AR'
}

/**
 * The available game modes.
 */
export enum GameModes {
  OutpostRun = 'OR',
  ZoneRush = 'ZR',
  Terraforming = 'TF'
}

export enum EArcadeGameId {
  KhBlockSquared = 'kh-block-squared',
  KhBlockCrush = 'kh-block-crush',
  KhMemorama = 'kh-memorama',
  KhConnectDuel = 'kh-connect-duel',
  KhDeflectorama = 'kh-deflectorama',
  KhFishQuest = 'kh-fish-quest',
  KhFlappyDuel = 'kh-flappy-duel',
  KhBubbleRumble = 'kh-bubble-rumble',
  KhBouncyHarvest = 'kh-bouncy-harvest',
  KhFalldown = 'kh-falldown',
  KhStoplightDash = 'kh-stoplight-dash',
  KhSheepIo = 'kh-sheep-io',
  KhSungoldFarm = 'kh-sungold-farm',
  KhZoGearSoccer = 'kh-zo-gear-soccer',
  KhBatterUp = 'kh-batter-up',
  KhLittleMixer = 'kh-little-mixer',
  KhRiftGlider = 'kh-riftglider',
  KhSpaceGrab = 'kh-space-grab',
  KhMatchingChef = 'kh-matching-chef',
  KhMergeMania = 'kh-merge-mania',
  GameTemplate = 'game-template'
}

export interface ArcadeGameConfig {
  id: string;
  name: string;
  description: string;
  thumbnail: string;
  tags: string[];
  /* workflow will use this to know where to make this accessible from,
  also client app will use it to navigate to */
  urlPath: string;
  // /* Workflow will use this to know where to get the files for this game to build it */
  // srcPath: string;
  enabled: boolean;
}

// Partial because some games could be not enabled in the config
export type ArcadeGameConfigList = Partial<Record<EArcadeGameId, ArcadeGameConfig>>;

/**
 * Game access information returned by games-list/by-user endpoint
 */
export interface GameAccess {
  id: string;
  gameMode: string;
  name: string;
  locked: boolean;
  lockReason?: GameDisallowedReason;
  playAfterGameShowUntil?: string | null;
}
